import { Fv, About, Problem, Choose, Service, Works, Voice, News, Banner, Contact } from "../components/Project";
import { Grid, Space } from "../components/Layout";
import { Media } from "../components/Object";

const Home = () => {

  return (
    <>
      <Fv></Fv>

      <About></About>
      <Problem></Problem>
      <Choose></Choose>
      <Service></Service>
      <Works></Works>
      <Voice></Voice>
      <News></News>
      <Banner></Banner>
      <Contact></Contact>
    </>
  );
};

export default Home;
